import ArchiveIcon from "@mui/icons-material/Archive";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import MovieIcon from "@mui/icons-material/Movie";
import TvIcon from "@mui/icons-material/Tv";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import WarningIcon from "@mui/icons-material/Warning";
import { IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { useMemo } from "react";

import { getActionBackgroundColor } from "../utils/archiverUtils";
import { darkTheme } from "../utils/Themes";

export default function CandidateCardHeader({
  candidateRoot,
  actionTypes,
  candidateTypes,
  onRootActionIconClick,
  onCandidateRootTypeOptionChange,
  onHide,
}) {
  const isSeries = useMemo(() => {
    return (
      candidateTypes.find((t) => t.value === candidateRoot.archiveCandidateType)?.label === "Series"
    );
  }, [candidateRoot.archiveCandidateType, candidateTypes]);

  const hasAlreadyExists = useMemo(() => {
    const candidates = candidateRoot.archiveCandidates ?? [];
    return (
      candidates.some((c) => c.episodeAlreadyExists) ||
      candidates.some((c) => (c.additionalEpisodes ?? []).some((a) => a.episodeAlreadyExists))
    );
  }, [candidateRoot]);

  const renderArchiveOrWarning = () => {
    if (hasAlreadyExists) {
      return (
        <IconButton
          id="Override"
          name={candidateRoot.path}
          onClick={onRootActionIconClick}
          style={{
            backgroundColor: getActionBackgroundColor(candidateRoot, "Override", actionTypes),
            color: darkTheme.palette.secondary.main,
            marginLeft: 10,
          }}
        >
          <ArchiveIcon />
        </IconButton>
      );
    }

    if (!candidateRoot.isValid) {
      return (
        <IconButton
          id="invalid"
          name={candidateRoot.path}
          onClick={onRootActionIconClick}
          style={{
            color: darkTheme.palette.secondary.main,
            marginLeft: 10,
          }}
        >
          <WarningIcon />
        </IconButton>
      );
    }

    return (
      <IconButton
        id="Archive"
        name={candidateRoot.path}
        onClick={onRootActionIconClick}
        style={{
          backgroundColor: getActionBackgroundColor(candidateRoot, "Archive", actionTypes),
          marginLeft: 10,
        }}
      >
        <ArchiveIcon />
      </IconButton>
    );
  };

  return (
    <>
      <Grid size={3}>
        <IconButton
          name={candidateRoot.path}
          id={candidateRoot.archiveCandidateType}
          onClick={onCandidateRootTypeOptionChange}
        >
          {isSeries ? <TvIcon fontSize="large" /> : <MovieIcon fontSize="large" />}
        </IconButton>
      </Grid>

      <Grid size={9}>
        <Grid container spacing={0} justifyContent="flex-end">
          <Grid>
            <IconButton
              id="Hide"
              name={candidateRoot.path}
              onClick={onHide}
              aria-label="hide"
              style={{
                backgroundColor: getActionBackgroundColor(candidateRoot, "Hide", actionTypes),
                marginLeft: 10,
              }}
            >
              <VisibilityOffIcon />
            </IconButton>
          </Grid>

          <Grid>
            <IconButton
              id="None"
              name={candidateRoot.path}
              onClick={onRootActionIconClick}
              aria-label="none"
              style={{
                backgroundColor: getActionBackgroundColor(candidateRoot, "None", actionTypes),
                marginLeft: 10,
              }}
            >
              <FilterNoneIcon />
            </IconButton>
          </Grid>

          <Grid>
            <IconButton
              id="Delete"
              name={candidateRoot.path}
              onClick={onRootActionIconClick}
              aria-label="delete"
              style={{
                backgroundColor: getActionBackgroundColor(candidateRoot, "Delete", actionTypes),
                marginLeft: 10,
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Grid>

          <Grid>{renderArchiveOrWarning()}</Grid>
        </Grid>
      </Grid>
    </>
  );
}
